<template>
	<svg :width="width" :height="height" viewBox="0 0 26 24" role="presentation" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M13.0129611,0.5 C16.8401604,0.5 19.8457039,1.44633465 22.0121833,3.37833298 C24.1634079,5.29672758 25.3094044,7.92507418 25.4746942,11.2507161 C25.5079931,11.6375303 25.5079931,11.9988334 25.4759584,12.3671423 C25.3093777,15.7435029 24.181342,18.3810541 22.0626937,20.2840607 C19.9294234,22.2002011 16.9062481,23.1363636 13.0129611,23.1363636 C9.08574812,23.1363636 6.04508709,22.2005898 3.91138404,20.2840607 C1.79530182,18.3833589 0.66743395,15.7498908 0.5,12.3980777 L0.5,12.3980777 L0.5,11.238407 C0.667503393,7.91858811 1.8133246,5.29436014 3.96189446,3.37833298 C6.1288165,1.44593993 9.15184222,0.5 13.0129611,0.5 Z"
			:fill="fill"
			:stroke="stroke"
			stroke-width="2"
		></path>
	</svg>
</template>

<script>
export default {
	props: {
		width: {
			type: Number,
			default: 26,
		},
		height: {
			type: Number,
			default: 24,
		},
		stroke: {
			type: String,
			default: "#000",
		},
		fill: {
			type: String,
			default: "none",
		},
	},
};
</script>

<style></style>
